/**
 * Replaces Next.js polyfill-module for modern browsers (see package.json browserslist).
 * Saves ~16 KiB; baseline APIs are native in Chrome 111+, Safari 16.4+, etc.
 * @see https://github.com/vercel/next.js/issues/86785
 */

if (typeof URL !== "undefined" && !("canParse" in URL)) {
	URL.canParse = function canParse(url, base) {
		try {
			return !!new URL(url, base);
		} catch {
			return false;
		}
	};
}
